module.exports = __webpack_public_path__ + "img/asynchro-250.61ee39ed.png";